
var app = angular.module('directives.googlePay', []);

require('./directives/googlePay.js');
require('./stylesheets/googlePay.scss');
require('./templates/index.html');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/googlePay/index.js
 ** module id = 164
 ** module chunks = 1
 **/